import ReactCountryFlag from "react-country-flag"
import { CountryCodes } from "../types/amazonAds"

const CountryFlag: React.FC<{ countryCode: CountryCodes }> = ({ countryCode }) => {
  return <ReactCountryFlag countryCode={countryCode} svg style={{ width: 24, height: 24 }} />
}

export default CountryFlag
